import React from 'react';
import { style } from 'typestyle';
import * as styles from './cards.styles';
import { CrossAxisAlignment } from '../../../core/components/flex/flex.component';
import Row from '../../../core/components/row/row.component';
import type PermittedUser from '../../offices/models/permitted-user';

interface Props {
  readonly permittedUser: PermittedUser;
  readonly onClick: (permittedUser: PermittedUser) => void;
}

const EmployeeCard = ({ permittedUser, onClick }: Props): React.JSX.Element => (
  <div
    className={style(styles.infoCard(true))}
    key={permittedUser.email}
    onClick={(): void => {
      onClick(permittedUser);
    }}
    role="presentation"
  >
    <Row crossAxisAlignment={CrossAxisAlignment.Center}>
      <span className={style(styles.cardHeader())}>{permittedUser.email}</span>
    </Row>
  </div>
);

export default EmployeeCard;
